import _defineProperty from "@babel/runtime/helpers/defineProperty";
export { Theme, Audience, PrivacyPolicyType, ButtonPosition, CornerRadius } from '@wix/ambassador-serverless-cookie-consent-settings-serverless/types';
export const DEFAULT_POLICY = {
  essential: true,
  functional: false,
  analytics: false,
  advertising: false
};
export class BaseComponent {
  constructor(props) {
    _defineProperty(this, "props", void 0);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "htmlElement", void 0);
    _defineProperty(this, "rendered", false);
    this.props = {
      ...(props || Object.create({})),
      ...BaseComponent.defaultProps
    };
    this.state = Object.create({});
  }
  setState(partial) {
    this.state = {
      ...this.state,
      ...partial
    };
    // const parent = this.htmlElement?.parentElement;
    // if (parent) {
    //   parent.removeChild(this.htmlElement);
    //   renderComponent(this, parent);
    // }
  }

  componentRendered() {
    // No-Op
  }
  onComponentUpdate() {}
}
_defineProperty(BaseComponent, "defaultProps", void 0);
//# sourceMappingURL=index.js.map